/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ApplicationSourcesControllerFindOneQueryResponse, ApplicationSourcesControllerFindOnePathParams, ApplicationSourcesControllerFindOneQueryParams, ApplicationSourcesControllerFindOne400, ApplicationSourcesControllerFindOne401, ApplicationSourcesControllerFindOne403, ApplicationSourcesControllerFindOne404 } from "../../models/checklistsController/ApplicationSourcesControllerFindOne";

function getApplicationSourcesControllerFindOneUrl(id: ApplicationSourcesControllerFindOnePathParams["id"]) {
  const res = { method: 'GET', url: `/api/v1/checklist-application-sources/${id}` as const }  
  return res
}

/**
 * @summary Get a specific checklist application source by ID
 * {@link /api/v1/checklist-application-sources/:id}
 */
export async function applicationSourcesControllerFindOne(id: ApplicationSourcesControllerFindOnePathParams["id"], params?: ApplicationSourcesControllerFindOneQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<ApplicationSourcesControllerFindOneQueryResponse, ResponseErrorConfig<ApplicationSourcesControllerFindOne400 | ApplicationSourcesControllerFindOne401 | ApplicationSourcesControllerFindOne403 | ApplicationSourcesControllerFindOne404>, unknown>({ method : "GET", url : getApplicationSourcesControllerFindOneUrl(id).url.toString(), params, ... requestConfig })  
  return res.data
}